import React from 'react';
import './AmPmToggle.css';

/**
 * F0 — Vertical 2-segment AM/PM pill toggle.
 *
 * Props:
 *   - value: 'AM' | 'PM'
 *   - onChange: (next: 'AM' | 'PM') => void
 *   - disabled
 *   - ariaLabel: announce-friendly group label
 */
const AmPmToggle = ({ value, onChange, disabled = false, ariaLabel = 'Meridiem' }) => {
  const handle = (next) => {
    if (disabled || next === value) return;
    onChange?.(next);
  };

  return (
    <div
      className={`appointments-v3-ampm ${disabled ? 'is-disabled' : ''}`}
      role="group"
      aria-label={ariaLabel}
    >
      <button
        type="button"
        className={`appointments-v3-ampm-seg ${value === 'AM' ? 'is-active' : ''}`}
        aria-pressed={value === 'AM'}
        aria-label="AM"
        disabled={disabled}
        onClick={() => handle('AM')}
      >
        AM
      </button>
      <button
        type="button"
        className={`appointments-v3-ampm-seg ${value === 'PM' ? 'is-active' : ''}`}
        aria-pressed={value === 'PM'}
        aria-label="PM"
        disabled={disabled}
        onClick={() => handle('PM')}
      >
        PM
      </button>
    </div>
  );
};

export default AmPmToggle;
